// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2646":"f59c2f4a","3602":"2b4bb42f","8857":"1d986c38"}[chunkId] + ".chunk.css";
};